import {AfterViewInit, Component, ElementRef, NgZone, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {PaymentData} from 'src/app/models/application/payment-data.model';
import {CompletePaymentRequest} from 'src/app/models/request/complete-payment-request.model';
import {SessionService} from 'src/app/services/session.service';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {Router} from '@angular/router';
import {DialogService} from 'src/app/services/dialog.service';
import {PaymentService} from 'src/app/services/payment.service';
import {Complement} from 'src/app/models/application/complement.model';
import {PurchaseUnit} from 'src/app/models/application/purchase-unit.model';
import * as CryptoJS from 'crypto-js';
import {ProductPaymentData} from 'src/app/models/application/product-payment-data.model';
import {DeviceDetectorService} from 'ngx-device-detector';

declare var paypal: any;

@Component({
    selector: 'app-payment',
    templateUrl: './payment.component.html',
    styleUrls: ['./payment.component.scss']
})
export class PaymentComponent implements OnInit, OnDestroy, AfterViewInit {

    constructor(
        private sessionService: SessionService,
        private dialogService: DialogService,
        private router: Router,
        private ngZone: NgZone,
        private paymentService: PaymentService,
        private deviceService: DeviceDetectorService
    ) {
        this.isMobile = this.deviceService.isMobile();
        this.isTablet = this.deviceService.isTablet();
        window.scrollTo(0, 0);
        this.userData = this.sessionService.getPaymentAccount();
        this.sessionService.genPaymentSteps();
        this.steps = this.sessionService.updateSteps();
        this.sessionService.updateStepsListener$.pipe(takeUntil(this.ngUnsubscribe)).subscribe(
            // tslint:disable-next-line:variable-name
            _next => {
                this.updateSteps();
                this.methodInfo = this.sessionService.getDataPay();
            }
        );
        this.sessionService.listenCartItems$.pipe(takeUntil(this.ngUnsubscribe)).subscribe(
            // tslint:disable-next-line:variable-name
            _data => {
                this.totalItems = this.countCartItems();
                if (this.totalItems === 0) {
                    this.withoutProductsAction();
                }
                this.preparePaypal();
            }
        );
        this.totalItems = this.countCartItems();
        if (this.totalItems === 0) {
            this.withoutProductsAction();
        }
        this.preparePaypal();
    }

    @ViewChild('paypal', {static: true}) paypalElem: ElementRef;
    private userData: any;
    tranSelect: any;
    methodInfo: any;
    errorData: any;
    data: PaymentData;
    steps: any;
    totalItems = 0;
    productsList: PaymentData[] = [];
    paypalProducts: PurchaseUnit;
    paymentMethod: any;
    totalMonth = 0;
    totalAnnual = 0;
    complementsAdd = false;
    numtransaction: number[] = [10, 20, 50, 100, 200, 500, 1000];
    pricetransaction: number[] = [200, 360, 800, 1500, 2800, 6500, 12000];
    pricetransactionUSD: number[] = [10, 18, 40, 75, 140, 325, 600];
    private ngUnsubscribe: Subject<any> = new Subject<any>();
    loader: boolean;
    /* VARIABLES PARA SABER SI SON MOVILES */
    isMobile: any = false;
    isTablet: any = false;

    payment(): void {
        this.loader = true;
        const request = new CompletePaymentRequest();
        const accountData = this.sessionService.getPaymentAccount();
        const billingData = this.sessionService.getPaymentBilling();
        request.user = {...accountData};
        request.currency = this.sessionService.getCountryData() ? '' : 'USD';
        request.user.maxSigns = Number.parseInt(this.productsList[0].transactions, 10);
        request.user.username = accountData.user;
        request.user.isCompany = this.productsList[0].product !== 'FAD® PERSONAL';
        request.user.isRecurrentPlan = this.productsList[0].subscription === 'Suscripción mensual';
        request.user.countryCode = accountData.countryCode;
        if (this.sessionService.getPromoCode()) {
            request.couponId = this.sessionService.getPromoCode().couponId;
        }
        request.card = {
            // @ts-ignore
            number: this.sessionService.getDataPay().creditCard,
            // @ts-ignore
            expMonth: this.sessionService.getDataPay().expiration.split('/')[0],
            // @ts-ignore
            expYear: this.sessionService.getDataPay().expiration.split('/')[1],
            // @ts-ignore
            cvc: this.sessionService.getDataPay().cvv
        };
        request.idSourceSystem = 4;
        request.language = 'es';
        request.tokenConekta = null;
        request.products = this.setProductsInCart();
        if (this.sessionService.getCountryData()) {
            // @ts-ignore
            request.tax = (this.getTotalDescuento() === null ? this.getIVA(this.getTotal() * .16)
                : this.getIVA(this.getTotalDescuento() * .16)) * 100;
        } else {
            request.tax = 0;
        }
        // tslint:disable-next-line:no-bitwise
        if (billingData.country === '' || billingData.country === null) {
            this.sessionService.setPaymentBilling(null);
            request.billing = null;
        } else {
            request.billing = {...billingData};
        }
        this.paymentService.sendOrder(request).subscribe(
            responseSendOrder => {
                this.loader = false;
                if (responseSendOrder.success) {
                    this.router.navigate(['/exito-compra-firma-digital']);
                    this.sessionService.setAccountData('USER_ACCOUNT');
                } else {
                    if (responseSendOrder.error === ('Your card was declined.')
                        || responseSendOrder.error === ('Your card has insufficient funds.')) {
                        this.errorData = 'Ocurrio un error con tu tarjeta, intenta con otra.';
                        if (billingData.country === '' || billingData.country === null) {
                            this.sessionService.setPaymentBilling(
                                {
                                    country: null,
                                    state: null,
                                    city: null,
                                    code: null,
                                    address: null,
                                    rfc: null,
                                    businessName: null
                                }
                            );
                        }

                    } else if (responseSendOrder.error.includes('No se pudo crear el usuario. Se agregaron')) {
                        this.router.navigate(['/exito-compra-firma-digital']);
                    } else if (responseSendOrder.error === ('No se pudo llenar el usuario.')) {
                        this.router.navigate(['/exito-compra-firma-digital']);
                    } else {
                        switch (responseSendOrder.error) {
                            case 'Your card number is incorrect.':
                                this.errorData = 'Ocurrio un error con tu tarjeta, intenta con otra.';
                                break;
                            case 'Your card has expired.':
                                this.errorData = 'Revisa los datos de tu tarjeta o intenta con otra.';
                                break;
                            case 'invalid_expiry_year':
                                this.errorData = 'La fecha de expiración es incorrecta, verifica los datos.';
                                break;
                            case 'Your card does not support this type of purchase.':
                                this.errorData = 'La transacción no se puede procesar, verifique los datos e intente nuevamente, use una tarjeta digital para compras más seguras.';
                                break;
                            default:
                                this.errorData = 'Ocurrio un error, intentalo más tarde.';
                                break;
                        }

                        if (billingData.country === '' || billingData.country === null) {
                            this.sessionService.setPaymentBilling({
                                country: null,
                                state: null,
                                city: null,
                                code: null,
                                address: null,
                                rfc: null,
                                businessName: null
                            });
                        }

                    }
                }
            },
            error => {
                this.errorData = 'Ocurrio un error en la compra, intentalo más tarde. ' + error;
            }
        );
    }

    ngOnInit(): void {

        this.sessionService.setPromoCode(null);
        onkeydown = ev => {
            if (ev.key === 'Tab') {
                return false;
            }
        };

        if (this.productsList.length > 0) {
            this.productsList.forEach(product => {
                if (product.type === 'anual' && product.product === 'FAD® PERSONAL') {
                    this.tranSelect = Number(product.transactions);
                }
            });
        }
        if (this.productsList[0].type === 'month') {
            this.setDataLayer();
        }
    }

    ngAfterViewInit(): void {
    }

    setTransacciones(x: number, item: PaymentData): void {
        item.transactions = `${x}`;
        item.pricing = this.sessionService.getCountryData() ? this.pricetransaction[this.numtransaction.indexOf(x)]
            : this.pricetransactionUSD[this.numtransaction.indexOf(x)];
        this.removeDataLayerProduct(item);
        // @ts-ignore
        window.dataLayer = window.dataLayer || [];
        // @ts-ignore
        dataLayer.push({ecommerce: null});
        // @ts-ignore
        dataLayer.push({
            event: 'addToCart',
            ecommerce: {
                currencyCode: 'MXN',
                add: {                                // 'add' actionFieldObject measures.
                    products: [{                        //  adding a product to a shopping cart.
                        name: 'FAD® Firma - Plan personal - Prepago anual',                      // Name or ID is required.
                        id: 'FADPPPA' + item.transactions,
                        price: item.pricing,
                        brand: 'FAD®',
                        category: 'FAD® Personal',
                        variant: 'Anual ' + item.transactions,
                        position: 2
                    }]
                }, detail: {
                    name: 'FAD® Firma - Plan personal - Prepago anual',                      // Name or ID is required.
                    id: 'FADPPPA' + item.transactions,
                    price: item.pricing,
                    brand: 'FAD®',
                    category: 'FAD® Personal',
                    variant: 'Anual ' + item.transactions,
                    position: 2
                }
            }
        });
        this.justUpdate(item);
    }

    setDataLayer(): void {
        // @ts-ignore
        window.dataLayer = window.dataLayer || [];
        // @ts-ignore
        dataLayer.push({ecommerce: null});
        // @ts-ignore
        dataLayer.push({
            event: 'transaction',
            ecommerce: {
                detail: {
                    actionField: {
                        list: 'FAD® Planes'
                    },
                    products: [
                        {
                            name: this.productsList[0].product === 'FAD® EMPRESA' ?
                                'FAD® Firma - Plan empresas - Suscripcion Mensual' : this.productsList[0].type === 'month' ?
                                    'FAD® Firma - Plan personal - Suscripción Mensual' : 'FAD® Firma - Plan personal - Prepago anual',
                            id: this.productsList[0].product === 'FAD® EMPRESA' ?
                                'FADPESM' : this.productsList[0].type === 'month' ? 'FADPPSM' :
                                    'FADPPPA' + this.productsList[0].transactions,
                            price: this.productsList[0].pricing,
                            brand: 'FAD®',
                            category: this.productsList[0].product === 'FAD® EMPRESA' ?
                                'FAD® Empresas' : 'FAD® Personal',
                            variant: this.productsList[0].product === 'FAD® EMPRESA' ?
                                'Suscripcion Ilimitada' : this.productsList[0].type === 'month' ?
                                    'Suscripcion Ilimitada' : 'Anual ' + this.productsList[0].transactions,
                            quantity: 1,
                        }
                    ]
                }
            }
        });
    }

    setProductsInCart(): ProductPaymentData[] {
        const productsData: ProductPaymentData[] = [];
        this.productsList.forEach(product => {
            const productTmp = new ProductPaymentData();
            productTmp.name = `${product.product} ${product.subscription}`;
            productTmp.price = (this.getTotalDescuento() === null ? product.pricing : this.getTotalDescuento()) * 100;
            productTmp.quantity = product.quantity;
            productTmp.suscriptionType = product.type === 'anual' ? 2 : 1;
            productsData.push(productTmp);
            product.complements.forEach(
                complement => {
                    const productComp = new ProductPaymentData();
                    if (complement.isAdd) {
                        productComp.name = complement.name;
                        productComp.price = complement.price * 100;
                        productComp.quantity = complement.quantity;
                        productComp.suscriptionType = 1;
                        productsData.push(productComp);
                        switch (complement.name) {
                            case 'Foto INE+Comparación de firma':
                                productComp.complements.ineFirma = false;
                                break;
                            case 'Foto INE':
                                productComp.complements.fotoINE = false;
                                break;
                            case 'Foto INE+Comparación de firma+comparación de videofirma vs foto INE':
                                productComp.complements.ineFirmaVideoFirma = false;
                                break;
                            case 'OTP vía WhatsApp':
                                productComp.complements.otpWhatsapp = false;
                                break;
                            case 'Versión WEB':
                                // productComp.complements
                                break;
                            case 'Foto INE+Comparación de firma+comparación de videoacuerdo vs foto INE':
                                productComp.complements.ineFirmaVideoAcuerdo = false;
                                break;
                            case 'Constancia de conservación en USA':
                                productComp.complements.constanciaUSA = false;
                                break;
                            case 'Foto INE+Comparación de firma+comparación de videoacuerdo y de videofirma vs foto INE':
                                // productComp.complements
                                break;
                            case 'Constancia de conservación en Blockchain (Etherium)':
                                productComp.complements.constanciaBlockChain = false;
                                break;
                        }
                    }
                }
            );
        });

        return productsData;
    }

    decryptData(data, key): string {
        const plainData = CryptoJS.AES.decrypt(data.toString(), key);
        return plainData.toString(CryptoJS.enc.Utf8);
    }

    getItemTotal(item: PaymentData): number {
        let count = item.pricing;
        item.complements.forEach(complement => {
            if (complement.isAdd) {
                count += complement.price;
            }
        });
        return count;
    }

    preparePaypal(): void {
        setTimeout(() => {
            try {
                const parentNodeCard = document.getElementById('paypal-container-card') as HTMLElement;
                parentNodeCard.innerHTML = '';
                this.paypalProducts = new PurchaseUnit();
                this.productsList.forEach(product => {
                    this.paypalProducts.description = this.paypalProducts.description
                        + ' - ' + `${product.product} ${product.subscription}`;
                    this.paypalProducts.amount.value += this.getItemTotal(product);
                });
                this.paypalProducts.amount.currency_code = 'MXN';
                paypal.Buttons(
                    {
                        style: {
                            color: 'black'
                        },
                        createOrder: (data, actions) => {
                            return actions.order.create(
                                {
                                    purchase_units: [
                                        {...this.paypalProducts}
                                    ],
                                    application_context: {
                                        shipping_preference: 'NO_SHIPPING'
                                    }
                                }
                            );
                        }
                    }
                )
                    .render(parentNodeCard);
            } catch (error) {
            }
        }, 500);
    }

    ngOnDestroy(): void {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }

    withoutProductsAction(): void {
        this.dialogService.showNotificationDialog('Sin productos', 'No tienes productos agregados al carrito');
        this.router.navigate(['/']);
    }

    justUpdate(item: PaymentData): void {
        this.sessionService.updateCartList(item, false, null, true);
    }

    updateCart(item: PaymentData, isAdd?: boolean, num?: number, justUpdate?: boolean): void {
        this.sessionService.updateCartList(item, isAdd, num, justUpdate);
    }

    deleteItem(item: PaymentData): void {
        this.dialogService.showConfirmationDialog(
            'Confirmar operación',
            '¿Estás seguro de querer remover este producto del carrito?',
            () => {
                this.updateCart(item);
                this.removeDataLayerProduct(item);
                this.sessionService.setPromoCode(null);
            }
        );
    }

    removeDataLayerProduct(item: any): any {
        // @ts-ignore
        window.dataLayer = window.dataLayer || [];
        // @ts-ignore
        dataLayer.push({ecommerce: null});
        if (item.product === 'FAD® PERSONAL') {
            if (item.type === 'month') {
                // @ts-ignore
                dataLayer.push({ecommerce: null});  // Clear the previous ecommerce object.
                // @ts-ignore
                dataLayer.push({
                    event: 'removeFromCart',
                    ecommerce: {
                        remove: {                               // 'remove' actionFieldObject measures.
                            products: [{                          //  removing a product to a shopping cart.
                                name: 'FAD® Firma - Plan personal - Suscripción Mensual',                      // Name or ID is required.
                                id: 'FADPPSM',
                                price: item.pricing,
                                brand: 'FAD®',
                                category: 'FAD® Personal',
                                variant: 'Suscripcion Ilimitada',
                                position: 1
                            }]
                        }
                    }
                });
            } else {
                // @ts-ignore
                dataLayer.push({ecommerce: null});  // Clear the previous ecommerce object.
                // @ts-ignore
                dataLayer.push({
                    event: 'removeFromCart',
                    ecommerce: {
                        remove: {                               // 'remove' actionFieldObject measures.
                            products: [{                          //  removing a product to a shopping cart.
                                name: 'FAD® Firma - Plan personal - Prepago anual',                      // Name or ID is required.
                                id: 'FADPPPA' + item.transactions,
                                price: item.pricing,
                                brand: 'FAD®',
                                category: 'FAD® Personal',
                                variant: 'Anual ' + item.transactions,
                                position: 2
                            }]
                        }
                    }
                });
            }
        } else {
            // @ts-ignore
            dataLayer.push({ecommerce: null});  // Clear the previous ecommerce object.
            // @ts-ignore
            dataLayer.push({
                event: 'removeFromCart',
                ecommerce: {
                    remove: {                               // 'remove' actionFieldObject measures.
                        products: [{                          //  removing a product to a shopping cart.
                            name: 'FAD® Firma - Plan empresas - Suscripcion Mensual',
                            id: 'FADPESM',
                            price: '499',
                            brand: 'FAD®',
                            category: 'FAD® Empresas',
                            variant: 'Suscripcion Ilimitada',
                            position: 1
                        }]
                    }
                }
            });
        }
    }

    countCartItems(): number {
        let count = 0;
        let aux = 0;
        let diferentP = false;
  /*      const items = this.sessionService.getCartItems();
        items.forEach(data => {
            count += data.quantity;
            data.complements.forEach(info => {
                if (info.isAdd) {
                    aux++;
                }
                if (aux === 0) {
                    this.complementsAdd = false;
                } else if (aux >= 1) {
                    this.complementsAdd = true;
                }
            });
        }); */
        if (this.userData === null) {
           // this.productsList = [...items];
        } else {
           // this.productsList = [...items];
            if (this.userData.isCompany) {
                this.productsList.forEach(
                    data => {
                        if (data.product === 'FAD® PERSONAL') {
                            this.updateCart(data);
                            diferentP = true;
                        }
                    }
                );
            } else {
                this.productsList.forEach(
                    data => {
                        if (data.product === 'FAD® EMPRESA') {
                            this.updateCart(data);
                            diferentP = true;
                        }
                    }
                );
            }
        }
        if (diferentP) {
            this.dialogService.showNotificationDialog('Notificación', 'Se eliminaron los productos que no cumplen con tu perfil.');
        }
        return count;
    }

    isComplete(): boolean {
        let res = false;
        if (this.userData && this.sessionService.getDataPay()){
            res = true;
        }
        return res;
    }

    updateSteps(): void {
        this.steps = {...this.sessionService.updateSteps()};
        if (this.steps.accountStep.completed) {
            this.userData = this.sessionService.getPaymentAccount();
            this.countCartItems();
        }
    }

    getIVA(total: any): any {
        return parseFloat(total).toFixed(2);
    }

    getTotalDescuento(): any {
        if (this.sessionService.getPromoCode()) {
            return parseFloat(String(this.sessionService.getPromoCode().amounts[0].amountAfterDiscount / 100)).toFixed(2);
        }
        return null;
    }

    getTotal(aux?: number): string {
        let total = 0;
        this.totalAnnual = 0;
        this.totalMonth = 0;
        // this.totalComplements = 0;
        const items = this.sessionService.getCartItems();
        items.forEach((data: PaymentData) => {
            total += data.pricing;
            if (data.type === 'month') {
                this.totalMonth += data.pricing;
            } else {
                this.totalAnnual += data.pricing;
            }
            data.complements.forEach((dataComplement: Complement) => {
                if (dataComplement.isAdd) {
                    if (data.type === 'month') {
                        this.totalMonth += dataComplement.price * dataComplement.quantity;
                    } else {
                        this.totalAnnual += dataComplement.price * dataComplement.quantity;
                    }
                    total += dataComplement.price * dataComplement.quantity;
                }
            });
        });
        if (aux === 1 && this.sessionService.getCountryData()) {
            total = Number.parseFloat(total.toString()) + Number.parseFloat(this.getIVA(total * 0.16));
        }
        return parseFloat(String(total)).toFixed(2);
    }

    getTotalIVA(total: any): any {
        if (this.getTotalDescuento() && this.sessionService.getCountryData()) {
            const totalDescuento: number = Number(parseFloat(this.getTotalDescuento()).toFixed(2)) +
                // @ts-ignore
                Number(parseFloat(this.getTotalDescuento() * .16).toFixed(2));
            return totalDescuento.toFixed(2);
        }
        return parseFloat(total).toFixed(2);
    }

    getPriceCentavos(price: number): any {
        return parseFloat(price.toString()).toFixed(2);
    }

    getTransacciones(data: PaymentData): string {
        switch (data.type) {
            case 'month':
                return ' Transacciones Ilimitadas ';
            case 'anual':
                return data.transactions + ' Transacciones ';
        }
    }
}
